import type { Breakpoint, DialogProps } from '@mui/material';
import { Dialog } from '@mui/material';

export interface DialogRootProps {
  children?: React.ReactNode;
  open: boolean;
  onClose?: DialogProps['onClose'];
  maxWidth?: Breakpoint | false;
}

/**
 * 대화상자 루트.
 *
 * TODO: #2079 LookoModal 스토리북 옮기고, 사용법 추가.
 */
export default function DialogRoot({ children, open, onClose, maxWidth = 'lg' }: DialogRootProps) {
  return (
    <Dialog
      open={open}
      maxWidth={maxWidth}
      keepMounted={false}
      scroll="paper"
      onClose={onClose}
      onWheel={e => e.stopPropagation()}
    >
      {children}
    </Dialog>
  );
}
